import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=0ab62f07&"
import script from "./Drawer.vue?vue&type=script&lang=ts&"
export * from "./Drawer.vue?vue&type=script&lang=ts&"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=0ab62f07&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports